import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PreviewAltCard,
} from "../../components/Component";
import Status from "../../MyComp/UI/form/Status";
import { Badge, Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import QualificationComponent from "../../MyComp/UI/form/QualificationComponent";
import EmailInput from "../../MyComp/UI/form/EmailInput";
import DateTimePicker from "../../pages/components/forms/DateTimePicker";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import SelectComponent from "../../MyComp/UI/form/SelectComponent";
import TextAreaInput from "../../MyComp/UI/form/TextAreaInput";
import { Navigate } from "react-router";
import MessageProfileSidebar from "../../pages/panel/e-commerce/support/MessageProfile";
import useLogout from "../../hooks/useLogout";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { getZipDetailsAPI } from "../../api/master/indes";
import { addTeleCallerUserAPI, getTeleCallerUserListAPI, updateTeleCallerUserAPI } from "../../api/TellecallerUser";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { updateStatusTellecaller } from "../../api/TellecallerUser";
import { helpSupportList } from "../../api/HelpAndSupport";
import { replySupport } from "../../api/HelpAndSupport";
import { FormGroup, Label, Input } from "reactstrap";

const User = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: "",
            email: "",
            mobile: "",
            full_address: "",
            pin_code: "",
            district: "",
            state: "",
            status: true,
        },
    });

    const { logout } = useLogout();

    // Separate table state from form
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [imageOpen, setImageOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState("Add");
    const [showUpdateConfirmModal, setShowUpdateConfirmModal] = useState(false);
    const [updateConfirmItem, setUpdateConfirmItem] = useState(null);
    const [replyMessage, setReplyMessage] = useState("");

    const columns = [
        {
            name: "Name",
            selector: (row) => row?.name || "N/A",
            sortable: true,
        },
        {
            name: "Mobile",
            selector: (row) => row?.mobile,
        },
        {
            name: "Message",
            selector: (row) => row?.message,
            wrap: true,
            cell: (row) => (
                <div style={{
                    maxWidth: "250px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>
                    {row.message}
                </div>
            )
        },
        {
            name: "Date and Time",
            selector: (row) => row?.date,
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => (
                <Badge
                    color={
                        row.status === "pending"
                            ? "warning"
                            : row.status === "resolved"
                                ? "success"
                                : "secondary"
                    }
                >
                    {row.status}
                </Badge>
            ),
        },
        {
            name: "Action",
            // width: "125px",
            cell: (row) => (
                <Button
                    outline
                    color="warning"
                    size="sm"
                    className="btn-icon"
                    onClick={() => handleReplyClick(row)}
                >
                    <Icon name="reply" />
                </Button>
            ),
        },
    ];


    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);


    const handleImageClose = () => {
        setImageOpen(!imageOpen);
    };

    useEffect(() => {
        getUserList();
    }, [mode]);

    const getUserList = () => {
        setTableLoading(true);

        const body = {
            page: currentPage,
            limit: perPage,
            search: "",
        };

        helpSupportList(body)
            .then((res) => {
                setTableLoading(false);

                if (res?.data?.status === true) {
                    const list = res?.data?.data?.data || [];

                    setTableData(list);
                    setTotalRows(res?.data?.data?.totalCount || 0);

                    // IMPORTANT for your table component
                    setValue("limit", res?.data?.data?.totalCount);
                    setValue("perPage", perPage);
                }
                else if (res?.data?.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                }
                else {
                    toast.error(res?.data?.message || "Failed to fetch data");
                }
            })
            .catch((err) => {
                setTableLoading(false);
                toast.error(err?.response?.data?.message || "API Failed");
            });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        const rows = isNaN(newPerPage) ? totalRows : newPerPage;
        setPerPage(rows);
        setValue("page", page);
        console.log("rows", page, rows);
    };

    const handlePageChange = (page) => {
        console.log("page", page);
        setPerPage(perPage);
        setCurrentPage(page);
        setValue("page", page);
    };



    useEffect(() => {
        serverSideSearch();
    }, [perPage, currentPage]);

    const serverSideSearch = (searchText = "") => {
        const body = {
            search: searchText,
            page: currentPage,
            limit: perPage,
        };

        setLoading(true);

        helpSupportList(body)
            .then((res) => {
                setLoading(false);

                if (res?.data?.status === true) {
                    setTableData(res?.data?.data?.data || []);
                    setTotalRows(res?.data?.data?.totalCount || 0);
                    setValue("limit", res?.data?.data?.totalCount);
                    setValue("perPage", perPage);
                }
                else if (res?.data?.status === "expired") {
                    logout();
                    toast.error(res.data.message);
                }
                else {
                    setTableData([]);
                }
            })
            .catch(() => setLoading(false));
    };

    useEffect(() => {
        if (watch("server_search")?.length == 0) {
            serverSideSearch();
        }
    }, [watch("server_search")]);


    const handleToggleStatus = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const confirmStatusChange = () => {
        const body = {
            id: selectedRow?.id,
            status: !selectedRow?.status,
        };

        setLoading(true);

        updateStatusTellecaller(body)
            .then((res) => {
                setLoading(false);
                if (res.data.status === true) {
                    toast.success(res.data.message);
                    serverSideSearch();
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message);
            })
            .finally(() => setShowModal(false));
    };

    const truncateByCharacters = (text = "", charLimit = 20) => {
        if (!text) return "";
        return text.length > charLimit
            ? text.slice(0, charLimit) + "..."
            : text;
    };

    const genderOption = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
    ];

    const handleEdit = (row) => {
        window.scrollTo(0, 0);
        setValue("selectedRow", row);
        setIsOpen(true);
        setMode("Edit");
        // setValue("user_img",row.image);
        const imageUrl = `${BASE_URL_IMG}${row.image}`;
        setValue("user_image", imageUrl);
        setValue("name", row.name);
        setValue("email", row.email);
        setValue("mobile", row.mobile);
        setValue("description", row.description);
        setValue("full_address", row.address);
        setValue("pin_code", row.pincode);
        setValue("district", row.district_name);
        setValue("state", row.state_name);

        setValue(
            "gender",
            genderOption?.find((item) => item.value === row.gender)
        );

        setValue("status", {
            label: row.status ? "Active" : "Inactive",
            value: row.status,
        });
        const body = {
            pin_code: row.pin_code,
        };
        // getZipDetails(body);
    };

    const closeUpdateConfirmModal = () => {
        setShowUpdateConfirmModal(false);
        setUpdateConfirmItem(null);
    };

    const handleReplyClick = (row) => {
        setUpdateConfirmItem(row);   // store clicked row data
        setShowUpdateConfirmModal(true); // open modal
    };

    const handleReplySubmit = () => {
        if (!replyMessage.trim()) {
            toast.error("Reply message is required");
            return;
        }

        const payload = {
            id: updateConfirmItem?.id,
            message: replyMessage,
            userId: updateConfirmItem?.userId,
            status: "resolved",
        };

        setLoading(true);

        replySupport(payload)
            .then((res) => {
                setLoading(false);

                if (res?.data?.status === true) {
                    toast.success(res.data.message);
                    setReplyMessage("");
                    setShowUpdateConfirmModal(false);
                    serverSideSearch(); // refresh table
                } else if (res?.data?.status === "expired") {
                    logout();
                    toast.error(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message || "Reply failed");
            });
    };


    return (
        <>
            <Head title="Users" />
            <Content>
                <BlockHead size="sm">
                    <BlockBetween className="flex-wrap gap-2">
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                Help and Support
                            </BlockTitle>
                        </BlockHeadContent>
                        {/* Admin not add user (manan sir) */}
                        <BlockHeadContent>

                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <Block>

                    <div className="table-responsive">
                        <ApiPaginationDataTable
                            data={tableData}
                            columns={columns}
                            title="Help and Support List"
                            isLoading={tableLoading}
                            register={register}
                            trigger={trigger}
                            watch={watch}
                            setValue={setValue}
                            errors={errors}
                            totalRows={totalRows}
                            perPage={perPage}
                            serverSearch
                            paginationServer
                            serverSideSearch={serverSideSearch}
                            handlePageChange={handlePageChange}
                            handlePerRowsChange={handlePerRowsChange}
                        />
                    </div>
                </Block>

            </Content>

            {/* <ConfirmModal
                isOpen={showModal}
                toggle={() => setShowModal(!showModal)}
                onConfirm={confirmStatusChange}
                status={selectedRow?.status}
            /> */}
            <Modal
                isOpen={showUpdateConfirmModal}
                toggle={closeUpdateConfirmModal}
                centered
                size="md"
                className="modal-dialog-scrollable"
            >
                <ModalHeader toggle={closeUpdateConfirmModal}>
                    Help and Support Details
                </ModalHeader>
                <ModalBody>
                    <div className="px-1 px-sm-3">
                        <p className="text-center fw-bold">
                            Reply to this support request
                        </p>

                        {updateConfirmItem && (
                            <div className="mt-3 small">
                                <p><strong>Name:</strong> {updateConfirmItem.name}</p>
                                <p><strong>Phone:</strong> {updateConfirmItem.mobile}</p>
                                <p style={{ wordBreak: "break-word" }}>
                                    <strong>Message:</strong> {updateConfirmItem.message}
                                </p>
                            </div>
                        )}

                        <FormGroup className="mt-3">
                            <Label>Reply Message</Label>
                            <Input
                                type="textarea"
                                rows="4"
                                value={replyMessage}
                                onChange={(e) => setReplyMessage(e.target.value)}
                                placeholder="Enter reply..."
                            />
                        </FormGroup>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {/* <Button color="danger" onClick={handleRejectUpdate}>
                                    Reject
                                </Button> */}
                    <Button
                        color="success"
                        // className="w-100 w-sm-auto"
                        onClick={handleReplySubmit}
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Reply"}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default User;
